import { has } from './has'
import { set } from './set'
import { remove } from './remove'

export const toggle = (element, attribute, value) => {
  has(element, attribute) ? set(element, attribute, value) : remove(element, attribute)
  console.log(`DEBUG (DOM.fns.dataset.toggle): Toggling ${value} for ${attribute} on:`, element)
}
